export const MIN_ITEM_LENGTH = 0.5;
export const INSERT_ITEM_LENGTH = 1.0;
export const AUTO_SNAP_DISTANCE = 0.05;
export const ZOOM_SPEED = .1;